import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode } from "vue"
import _imports_0 from '@/images/perma_logo.png'
import _imports_1 from '@/images/small_default_logo.png'
import _imports_2 from '@/images/recent_orders.png'
import _imports_3 from '@/images/user.png'
import _imports_4 from '@/images/menu.png'


const _hoisted_1 = { class: "fixed mt-0 w-full z-30" }
const _hoisted_2 = {
  href: "https://www.permaswap.network/",
  target: "_blank",
  class: "md:flex-1"
}
const _hoisted_3 = { class: "w-max flex items-end" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: "perma logo",
  class: "h-8 sm:block hidden"
}, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_1,
  alt: "default small logo",
  class: "h-8 sm:hidden block"
}, null, -1)
const _hoisted_6 = { class: "text-12px leading-5 ml-2 border border-permaGreen2 border-opacity-25 rounded px-1 text-permaWhite2" }
const _hoisted_7 = { class: "flex-1 lg:block hidden relative" }
const _hoisted_8 = { class: "flex justify-center text-base text-permaWhite1" }
const _hoisted_9 = {
  key: 0,
  class: "absolute -right-3.5 top-0 rounded-full h-2 w-2 overflow-hidden bg-permaRed"
}
const _hoisted_10 = ["href"]
const _hoisted_11 = { class: "flex flex-1 justify-end items-center relative" }
const _hoisted_12 = { class: "tradingModal" }
const _hoisted_13 = { class: "flex relative items-center" }
const _hoisted_14 = { class: "rencentOrdersModal" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_2,
    class: "w-6 h-6",
    alt: "recentOrders"
  })
], -1)
const _hoisted_16 = { class: "accountModal" }
const _hoisted_17 = {
  key: 0,
  class: "flex items-center flex-nowrap"
}
const _hoisted_18 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  class: "mr-1 w-6 h-6",
  alt: "user"
}, null, -1)
const _hoisted_19 = { class: "whitespace-nowrap" }
const _hoisted_20 = {
  key: 1,
  class: "flex items-center"
}
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/_createElementVNode("div", { class: "w-px h-5 bg-permaGreen2 bg-opacity-25 mx-3 mb:block hidden" }, null, -1)
const _hoisted_23 = { class: "ml-2 mb:ml-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("img", {
  src: _imports_4,
  class: "w-6 h-6",
  alt: "menu"
}, null, -1)
const _hoisted_25 = { class: "flex-1 px-6 lg:hidden block" }
const _hoisted_26 = { class: "flex justify-center flex-col text-base text-permaWhite1" }
const _hoisted_27 = ["onClick"]
const _hoisted_28 = ["href"]
const _hoisted_29 = ["href"]

import { computed, ref, onMounted } from 'vue'
import { useI18n } from 'vue-i18n'
import MoreModal from '../MoreModal/index.vue'
import NavbarSection from './NavbarSection.vue'
import { checkParentsHas } from '@/libs/util'
import { useStore } from '@/store'
import { useRoute, useRouter } from 'vue-router'
import RecentOrders from '@/pages/RecentOrders/index.vue'
import { addEvent } from '@/pages/swap/index'
import AssetModal from '../AssetModal/index.vue'
import { ImgConnectAppName, isProd } from '@/constants'
import NoticeBoard from '../NoticeBoard.vue'
import TradingModal from '../TradingModal/index.vue'

export default /*#__PURE__*/_defineComponent({
  props: {
    windowWidth: null,
    scrollTop: null
  },
  setup(__props: any) {

const { t } = useI18n()
const store = useStore()
const route = useRoute()
const router = useRouter()

const noticeBoardVisible = ref(false)
const routeName = computed(() => route.name as string)
const assetModalVisible = ref(false)
const moreModalVisible = ref(false)
const recentOrdersModalVisible = ref(false)
const tradingModalVisible = ref(false)
const connectModalVisible = computed(() => store.state.connectModalVisible)
const isMoreModalTarget = checkParentsHas('moreModal')
const isAccountModalTarget = checkParentsHas('accountModal')
const isRencentOrdersModalTarget = checkParentsHas('rencentOrdersModal')
const isTradingModalTarget = checkParentsHas('tradingModal')

const shortAccount = computed(() => {
  return store.getters.shortAccount(4, -2)
})
const navBarClass = computed(() => {
  let className = ''
  if (route.name === 'nft') {
    className = 'nft_navbar'
  } else {
    className = 'swap_pool_navbar'
  }
  return className
})
const connected = computed(() => {
  const account = store.state.account
  return account !== undefined && account !== null && account !== ''
})
const prefixLogo = computed(() => {
  const connectAppName = store.state.connectAppName
  if (connectAppName) {
    return ImgConnectAppName[connectAppName]
  } else {
    return ''
  }
})
const navbarList = computed(() => {
  return [
    {
      title: 'swap',
      to: `https://app${isProd ? '' : '-dev'}.permaswap.network`,
      routeNames: ['swap'],
      open: true
    },
    {
      title: 'pool',
      to: `https://app${isProd ? '' : '-dev'}.permaswap.network/pool`,
      routeNames: ['pool'],
      open: true
    },
    {
      title: 'nfts',
      to: `https://app${isProd ? '' : '-dev'}.permaswap.network/nft`,
      routeNames: ['nft'],
      open: true
    }
  ]
})
const goToPage = (to:string) => {
  router.push(to)
  moreModalVisible.value = false
}

const showAccountModal = () => {
  moreModalVisible.value = !moreModalVisible.value
  assetModalVisible.value = false
  tradingModalVisible.value = false
  recentOrdersModalVisible.value = false
}
const showAssetModal = () => {
  assetModalVisible.value = !assetModalVisible.value
  recentOrdersModalVisible.value = false
  tradingModalVisible.value = false
  moreModalVisible.value = false
}
const showRecentOrdersModal = () => {
  recentOrdersModalVisible.value = !recentOrdersModalVisible.value
  moreModalVisible.value = false
  assetModalVisible.value = false
  tradingModalVisible.value = false
}
const showTradingModal = () => {
  tradingModalVisible.value = !tradingModalVisible.value
  moreModalVisible.value = false
  assetModalVisible.value = false
  recentOrdersModalVisible.value = false
}
onMounted(async () => {
  document.addEventListener('click', (e) => {
    if (!isMoreModalTarget(e.target as any)) {
      moreModalVisible.value = false
    }
    if (!isAccountModalTarget(e.target as any)) {
      if (!connectModalVisible.value) {
        assetModalVisible.value = false
      }
    }
    if (!isRencentOrdersModalTarget(e.target as any)) {
      recentOrdersModalVisible.value = false
    }
    if (!isTradingModalTarget(e.target as any)) {
      tradingModalVisible.value = false
    }
  })
  addEvent('resize', () => {
    moreModalVisible.value = false
    recentOrdersModalVisible.value = false
    assetModalVisible.value = false
    tradingModalVisible.value = false
  })
})

return (_ctx: any,_cache: any) => {
  const _component_RouterLink = _resolveComponent("RouterLink")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["md:px-8 xl:px-16 w-full flex flex-row items-center justify-between px-4 h-20", [__props.scrollTop > 0 || assetModalVisible.value || recentOrdersModalVisible.value ? _unref(navBarClass) : '']])
    }, [
      _createElementVNode("a", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(isProd) ? 'Beta' : 'TestNet'), 1)
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbarList), (item, index) => {
            return (_openBlock(), _createElementBlock("div", {
              key: index,
              class: _normalizeClass([index === _unref(navbarList).length - 1 ? '' : 'mr-16', "hover:text-white whitespace-nowrap transition-colors relative"])
            }, [
              (!item.open)
                ? (_openBlock(), _createBlock(_component_RouterLink, {
                    key: 0,
                    to: item.to,
                    class: _normalizeClass(item.routeNames.includes(_unref(routeName)) ? 'text-permaGreen4' : '')
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_unref(t)(item.title)) + " ", 1),
                      (item.title === 'pool')
                        ? (_openBlock(), _createElementBlock("div", _hoisted_9))
                        : _createCommentVNode("", true)
                    ]),
                    _: 2
                  }, 1032, ["to", "class"]))
                : (_openBlock(), _createElementBlock("a", {
                    key: 1,
                    href: item.to,
                    target: "_blank"
                  }, _toDisplayString(_unref(t)(item.title)), 9, _hoisted_10))
            ], 2))
          }), 128))
        ])
      ]),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("div", _hoisted_12, [
          false
            ? (_openBlock(), _createBlock(TradingModal, {
                key: 0,
                visible: tradingModalVisible.value,
                onClose: _cache[0] || (_cache[0] = ($event: any) => (tradingModalVisible.value = false)),
                onShowModal: showTradingModal
              }, null, 8, ["visible"]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("div", {
              class: "md:block hidden",
              onClick: showRecentOrdersModal
            }, [
              _createVNode(NavbarSection, {
                class: _normalizeClass(["bg-permaGreen1 p-2 w-10 transition-colors box-border mr-2 opacity-80 hover:opacity-100", recentOrdersModalVisible.value ? 'text-white border-permaGreen9' : 'hover:border-permaGreen11 border-permaGreen2 border-opacity-25 text-permaWhite1 hover:text-white'])
              }, {
                default: _withCtx(() => [
                  _hoisted_15
                ]),
                _: 1
              }, 8, ["class"])
            ]),
            _createVNode(RecentOrders, {
              visible: recentOrdersModalVisible.value,
              title: _unref(t)('transaction_records'),
              onClose: _cache[1] || (_cache[1] = ($event: any) => (recentOrdersModalVisible.value = false))
            }, null, 8, ["visible", "title"])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createVNode(NavbarSection, {
              class: _normalizeClass(["bg-permaGreen border-permaGreen2 text-permaWhite1 hover:text-white pl-2 pr-3 py-2 hover:border-opacity-50 transition-colors", assetModalVisible.value ? 'border-opacity-50' : 'border-opacity-25']),
              onClick: showAssetModal
            }, {
              default: _withCtx(() => [
                (!_unref(connected))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
                      _hoisted_18,
                      _createElementVNode("span", _hoisted_19, _toDisplayString(_unref(t)('nav_connect')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                      (_unref(prefixLogo))
                        ? (_openBlock(), _createElementBlock("img", {
                            key: 0,
                            src: require(`@/images/connectWallet/${_unref(prefixLogo)}`),
                            class: "mr-1 w-6 h-6",
                            alt: "wallet"
                          }, null, 8, _hoisted_21))
                        : _createCommentVNode("", true),
                      _createElementVNode("span", null, _toDisplayString(_unref(shortAccount)), 1)
                    ]))
              ]),
              _: 1
            }, 8, ["class"]),
            _createVNode(AssetModal, {
              visible: assetModalVisible.value,
              title: "Asset",
              "short-account": _unref(shortAccount),
              onClose: _cache[2] || (_cache[2] = ($event: any) => (assetModalVisible.value = false))
            }, null, 8, ["visible", "short-account"])
          ]),
          _hoisted_22,
          _createElementVNode("div", _hoisted_23, [
            _createVNode(NavbarSection, {
              class: "bg-permaGreen1 w-10 transition-colors p-2 hover:border-permaGreen11 moreModal border-permaGreen2 border-opacity-25",
              onClick: showAccountModal
            }, {
              default: _withCtx(() => [
                _hoisted_24
              ]),
              _: 1
            }),
            _createVNode(MoreModal, {
              visible: moreModalVisible.value,
              connected: _unref(connected),
              onRecentMdalVisible: _cache[3] || (_cache[3] = ($event: any) => (recentOrdersModalVisible.value = true)),
              onClose: _cache[4] || (_cache[4] = ($event: any) => (moreModalVisible.value = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_25, [
                  _createElementVNode("div", _hoisted_26, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(navbarList), (item, index) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "hover:text-white transition-colors mb-4 cursor-pointer"
                      }, [
                        (!item.open)
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(item.routeNames.includes(_unref(routeName)) ? 'text-permaGreen4' : ''),
                              onClick: ($event: any) => (goToPage(item.to))
                            }, _toDisplayString(_unref(t)(item.title)), 11, _hoisted_27))
                          : (_openBlock(), _createElementBlock("a", {
                              key: 1,
                              href: item.to,
                              target: "_blank"
                            }, _toDisplayString(_unref(t)(item.title)), 9, _hoisted_28))
                      ]))
                    }), 128))
                  ])
                ])
              ]),
              _: 1
            }, 8, ["visible", "connected"])
          ])
        ])
      ])
    ], 2),
    (noticeBoardVisible.value)
      ? (_openBlock(), _createBlock(NoticeBoard, {
          key: 0,
          duration: 15,
          onClose: _cache[5] || (_cache[5] = ($event: any) => (noticeBoardVisible.value = false))
        }, {
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              _createTextVNode(_toDisplayString(_unref(t)('notice_board_msg')) + " ", 1),
              _createElementVNode("a", {
                href: `https://app${_unref(isProd) ? '' : '-dev'}.permaswap.network/pool`,
                target: "_blank",
                class: "underline underline-offset-2 px-1 text-permaGreen4"
              }, _toDisplayString(_unref(t)('go_to_download')), 9, _hoisted_29)
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ]))
}
}

})